<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" (ngModelChange)="changeEvent()" class="main-border-class"
          min="2020-11-01" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" (ngModelChange)="changeEvent()" class="main-border-class"
          [min]="from_date" />
      </div>
      <div class="col-2">
        <mat-label>Select Booth Types</mat-label>
        <mat-select [(ngModel)]="selected_business_type_ids" multiple class="main-border-class">
          <mat-option *ngFor="let booth of booth_types" [value]="booth.id">{{booth.name}}</mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 11%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null">Get</button>
      </div>
      <div *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
    </div>
    <div class="row">
      <div *ngIf="document_data!== null" style="text-align: right;" class="col">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i
            class="material-icons">
            get_app
          </i> Download Excel</button>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="document_data!== null" style="overflow: scroll;display: block;">
    <div class="col" class="table-wrapper">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Booth Code</th>
            <th>Agent Name</th>
            <th>Wallet At The Start Of Date</th>
            <th>Paid At Counter</th>
            <th>Paid Via Online</th>
            <th>Deposited Via Bot</th>
            <th>Wallet At The End Of Date</th>
            <th>Total Paid Amount</th>
            <th *ngFor="let product of document_data['product_list']">{{product}}</th>
            <th>Total Amount</th>
            <th>Difference</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sale of document_data['sale_group_data']; let business_index=index">
            <td>{{ business_index +1 }}</td>
            <td>{{ sale['business_code'] }}</td>
            <td>{{ sale['agent_name'] }}</td>
            <td style="text-align: right">{{ sale['wallet_before_amount'] }}</td>
            <td style="text-align: right">
              <button *ngIf="sale['counter_amount'] !== 0" mat-button class="amount-button"
                (click)="counterReportCalled(sale['business_code'], from_date, to_date)">{{ sale['counter_amount'] }}</button>
              <span *ngIf="sale['counter_amount'] == 0">{{ sale['counter_amount'] }}</span>
            </td>
            <td style="text-align: right">
              <button *ngIf="sale['online_amount'] !== 0" mat-button class="amount-button"
              (click)="onlineReportCalled(sale['business_code'], from_date, to_date)">{{ sale['online_amount'] }}</button>
              <span *ngIf="sale['online_amount'] == 0">{{ sale['online_amount'] }}</span>
            </td>
            <td style="text-align: right">
              <button *ngIf="sale['deposited_amount'] !== 0" mat-button class="amount-button"
                (click)="depositAmountCalled(sale['business_code'], from_date, to_date)">{{ sale['deposited_amount'] }}</button>
              <span *ngIf="sale['deposited_amount'] == 0">{{ sale['deposited_amount'] }}</span>
            </td>
            <td style="text-align: right">
              <button *ngIf="sale['wallet_after_amount'] !== 0" mat-button
                class="amount-button" (click)="walletReportCalled(sale['business_code'], from_date, to_date)">{{ sale['wallet_after_amount'] }}</button>
              <span *ngIf="sale['wallet_after_amount'] == 0">{{ sale['wallet_after_amount'] }}</span>
            </td>
            <td>{{ sale['total_amount_paid'] }}</td>
            <td *ngFor="let product of document_data['product_list']" style="text-align: right">
              <span *ngIf="sale.hasOwnProperty(product)">
                {{ sale[product] }}
              </span>
              <span *ngIf="!sale.hasOwnProperty(product)">
                0
              </span>
            </td>
            <td style="text-align: right">
              <button *ngIf="sale['product_total_amount'] !== 0" mat-button (click)="ProductReportCalled(sale['business_code'], from_date, to_date)"
                class="amount-button">{{ sale['product_total_amount'] }}</button>
              <span *ngIf="sale['product_total_amount'] == 0">{{ sale['product_total_amount'] }}</span>
            </td>
            <td style="text-align: right">{{ sale['difference'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
